// extracted by mini-css-extract-plugin
module.exports = {"container":"customer-care_container__ol1Qp","gradient":"customer-care_gradient__lC0OF","link":"customer-care_link__ST6zZ"};